import type { DocNode } from '@atlaskit/adf-schema/doc';

import type { AdfNode } from './contentOverflowPlugin.ts';
import { getCharacterCount } from './contentOverflowPlugin.ts';
import { parseBannerContent } from './parseBannerContent.ts';
import { MAX_CONTENT_CHARACTER_COUNT_SINGLE_LINE } from './validateContent.ts';

// Note: This check relies on MAX_CONTENT_CHARACTER_COUNT_SINGLE_LINE, which is an approximation for how many
// characters fit on a single line within a banner.
export const isCharacterCountSingleLine = (characterCount: number): boolean =>
	characterCount <= MAX_CONTENT_CHARACTER_COUNT_SINGLE_LINE;

export const isBannerContentSingleLineFromDocNode = (docNode: DocNode): boolean => {
	// DocNode with an empty content property corresponds with empty banner content, which is valid and is a single line
	if (!docNode.content) {
		return true;
	}
	const nodes = docNode.content as AdfNode[];
	const characterCount = getCharacterCount(nodes);
	return isCharacterCountSingleLine(characterCount);
};

export const isBannerContentSingleLineFromJSONString = (content: string): boolean => {
	const docNode = parseBannerContent(content);
	return isBannerContentSingleLineFromDocNode(docNode);
};
